<template>
  <challenge-layout
    :with-ribbon="false"
    :time-until-challenge-start="timeUntilChallengeStart"
    :challenge-header-props="{
      challengeName: challenge.name,
      shortDescription: challenge.shortDescription ?? '',
    }"
  >
    <template v-slot:cards>
      <welcome-to-challenge-card
        :first-name="firstName ?? ''"
        :start-date="challenge.startDate"
      />
    </template>
    <template v-slot:info>
      <div class="challenge-info">
        <days-view
          :start-date="challenge.startDate"
          :end-date="challenge.endDate"
          :disabled="true"
        />
        <story-list
          v-if="challenge.stories?.length > 0"
          :stories="challenge.stories"
        />
        <invite-friends-card />
        <participant-summary :number-of-participants="challenge.participants?.length" />
      </div>
    </template>
  </challenge-layout>
</template>

<script lang="ts" setup>
import { storeToRefs } from 'pinia';
import ChallengeHeader from '../ChallengeHeader/ChallengeHeader.vue';
import ChallengeLayout from '../../layouts/ChallengeLayout.vue';
import ParticipantSummary from '../ChallengeInfo/ParticipantSummary.vue';
import DaysView from '../ChallengeInfo/DaysView.vue';
import { useChallengeStore } from '../../stores/challenge';
import StoryList from '../ChallengeStory/StoryList.vue';
import WelcomeToChallengeCard from './WelcomeToChallengeCard.vue';
import InviteFriendsCard from '../Common/InviteFriendsCard.vue';
import useTrackDashboardVisit from '../../composables/useTrackDashboardVisit';

const challengeStore = useChallengeStore();
const {
  challenge,
  timeUntilChallengeStart,
  challengeGoal,
  firstName,
} = storeToRefs(challengeStore);

const { trackDashboardVisitedEvent } = useTrackDashboardVisit();
trackDashboardVisitedEvent('challenge_not_started_dashboard_page');
</script>

<style lang="scss" scoped>
@import '@riseupil/base-ui/src/scss/spacings';
@import '@riseupil/base-ui/src/scss/riseup-colors';

.header-section {
  height: 198px;
  display: grid;
  grid-template-columns: 2.5fr 0.5fr;
  gap: 16px;

  .header-texts {
    display: flex;
    flex-direction: column;
    align-self: center;

  }
}

.challenge-info {
  display: flex;
  flex-direction: column;
  height: 100%;
  margin-bottom: $ri-spacing-m;

  .separator {
    border-bottom: 1px solid $riseup_gray_0;
  }
}
</style>
